const TOPICS = {
  higherLimit: 'I%20need%20higher%20data%20limit',
  renewLicense: 'I%20need%20to%20renew%20my%20license',
};

const getQueryParams = ({
  organization,
  email,
  topic,
}) => {
  const queryParams = [];

  if (organization) queryParams.push(`account=${organization}`);
  if (email) queryParams.push(`user=${email}`);
  if (topic) queryParams.push(`topic=${TOPICS[topic]}`);

  return queryParams.join('&');
};

const getContactLink = ({ language, organization, email, topic }) => {
  const queryParams = getQueryParams({ organization, email, topic });
  let contactLink = [];

  switch (language) {
    case 'en':
      contactLink = ['https://piwik.pro/product-contact/']; break;
    case 'de':
      contactLink = ['https://piwikpro.de/product-contact/']; break;
    case 'fi':
      contactLink = ['https://piwik.pro/fi-product-contact/']; break;
    case 'fr':
      contactLink = ['https://piwikpro.fr/product-contact/']; break;
    case 'nl':
      contactLink = ['https://piwikpro.nl/product-contact/']; break;
    case 'se':
      contactLink = ['https://piwikpro.se/product-contact/']; break;
    default:
      contactLink = ['https://piwik.pro/product-contact/']; break;
  }
  if (queryParams) contactLink.push(queryParams);

  return contactLink.join('?');
};

export default getContactLink;
